import { ListLimitActions } from '@@hooks/utils/useListLimit';
import Button from '@mui/material/Button';

// import { BiShowAlt } from 'react-icons/bi';

/**
 * Types
 */
type ShowMoreButtonProps = {
  max: number;
  current: number;
  disabled?: boolean;
  increase: ListLimitActions['increase'];
};

/**
 * Component:
 */
const ShowMoreButton = ({ current, max, increase, disabled }: ShowMoreButtonProps) => {
  if (disabled) return null;

  return (
    <div className="col-span-full grid place-items-center py-2">
      <Button
        className="flex-col leading-tight "
        size="small" //
        onClick={() => increase()}
        // startIcon={<BiShowAlt />}
        // endIcon={<BiShowAlt />}
      >
        <p>Mutass többet</p>
        <p className="font-black">
          {current} / {max}
        </p>
        {/* <BiShowAlt size="1.5rem" /> */}
      </Button>
    </div>
  );
};

export default ShowMoreButton;
